// extracted by mini-css-extract-plugin
export default {"asterisk":"asterisk---IvhtZ","hasError":"hasError---AKzkm"};